/* ─────────────────────────────────────────────────────────────────────
   Tykables 7.0 — Mobile bottom tab bar behavior
   • Keeps the cart-tab badge in sync with Dawn's cartUpdate pub/sub event
   • Optionally opens the cart-drawer instead of navigating to /cart
   ───────────────────────────────────────────────────────────────────── */

(function () {
  'use strict';

  var nav = document.querySelector('[data-tyk-mobnav]');
  if (!nav) return;

  var badge = nav.querySelector('[data-tyk-mobnav-cart-count]');
  var cartTab = nav.querySelector('[data-tyk-mobnav-tab="cart"]');
  var openDrawer = nav.getAttribute('data-open-cart-drawer') === 'true';

  /* ── Badge helpers ─────────────────────────────────────────────── */
  function setBadge(count) {
    if (!badge) return;
    var n = Math.max(0, parseInt(count, 10) || 0);
    if (n === 0) {
      badge.classList.add('is-hidden');
      badge.textContent = '0';
    } else {
      badge.classList.remove('is-hidden');
      badge.textContent = n > 99 ? '99+' : String(n);
    }
  }

  /* ── Subscribe to Dawn's cart update event ─────────────────────── */
  function wirePubSub() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') {
      return false;
    }
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      var data = event && event.cartData;
      if (!data) return;
      if (typeof data.item_count === 'number') {
        setBadge(data.item_count);
      }
    });
    return true;
  }

  /* Dawn's pubsub.js loads deferred — retry briefly if not ready yet */
  if (!wirePubSub()) {
    var tries = 0;
    var tid = setInterval(function () {
      tries += 1;
      if (wirePubSub() || tries > 20) {
        clearInterval(tid);
      }
    }, 150);
  }

  /* ── Fallback: poll /cart.js when page becomes visible ─────────── */
  /* Covers edge cases where another tab adds items or a third-party
     app mutates the cart without publishing a cartUpdate event. */
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState !== 'visible') return;
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) { if (cart) setBadge(cart.item_count); })
      .catch(function () { /* swallow */ });
  });

  /* ── Cart tab → open cart drawer instead of navigating ─────────── */
  if (openDrawer && cartTab) {
    cartTab.addEventListener('click', function (e) {
      /* Honour modifier keys / middle-click by letting those through */
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;

      /* Don't hijack on the /cart page itself */
      if (window.location.pathname.indexOf('/cart') === 0) return;

      var drawer = document.querySelector('cart-drawer');
      if (!drawer || typeof drawer.open !== 'function') return;

      e.preventDefault();

      /* Dawn's CartDrawer#open expects a summoning element that will
         receive focus when the drawer closes — pass the tab itself. */
      drawer.open(cartTab);
    });
  }

  /* ── Active-state refresh on soft navigations (back/forward) ──── */
  window.addEventListener('pageshow', function () {
    /* Re-read the cart count from any existing bubble in the header
       in case the page was restored from bfcache with stale state. */
    var bubble = document.querySelector('.cart-count-bubble [aria-hidden="true"]');
    if (bubble && bubble.textContent) {
      setBadge(bubble.textContent);
    }
  });

  /* ═══════════════════════════════════════════════════════════════════
     Slide-up navigation panel
     ═══════════════════════════════════════════════════════════════════ */
  var panel = document.getElementById('tyk-mobnav-panel');
  if (panel) {
    var sheet = panel.querySelector('[data-tyk-mobnav-panel-sheet]');
    var handle = panel.querySelector('[data-tyk-mobnav-panel-handle]');
    var openers = document.querySelectorAll('[data-tyk-mobnav-panel-open]');
    var closers = panel.querySelectorAll('[data-tyk-mobnav-panel-close]');
    var lastFocused = null;

    function openPanel(trigger) {
      lastFocused = trigger || document.activeElement;
      panel.removeAttribute('hidden');
      /* force a reflow so the transition plays */
      // eslint-disable-next-line no-unused-expressions
      panel.offsetHeight;
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      document.body.classList.add('tyk-mobnav-panel-open');
      openers.forEach(function (o) { o.setAttribute('aria-expanded', 'true'); });

      /* Focus the close button for screen readers (after transition starts) */
      setTimeout(function () {
        var closeBtn = panel.querySelector('.tyk-mobnav-panel__close');
        if (closeBtn) closeBtn.focus({ preventScroll: true });
      }, 50);
    }

    function closePanel() {
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('tyk-mobnav-panel-open');
      openers.forEach(function (o) { o.setAttribute('aria-expanded', 'false'); });

      /* Wait for the slide-down to finish before hiding from the a11y tree */
      var hideAfter = function () {
        panel.setAttribute('hidden', '');
        /* Collapse any open disclosure groups so panel re-opens in a clean state */
        panel.querySelectorAll('details[open]').forEach(function (d) { d.open = false; });
        if (lastFocused && typeof lastFocused.focus === 'function') {
          lastFocused.focus({ preventScroll: true });
        }
        sheet && sheet.removeEventListener('transitionend', hideAfter);
      };
      if (sheet) {
        sheet.addEventListener('transitionend', hideAfter, { once: true });
        /* Fallback if transitionend doesn't fire (reduced motion, etc.) */
        setTimeout(hideAfter, 400);
      } else {
        hideAfter();
      }
    }

    /* Wire openers — the button already has type="button" so no extra prevention */
    openers.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (panel.classList.contains('is-open')) {
          closePanel();
        } else {
          openPanel(btn);
        }
      });
    });

    /* Wire closers (backdrop + close button) */
    closers.forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        closePanel();
      });
    });

    /* Escape key closes */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel.classList.contains('is-open')) {
        closePanel();
      }
    });

    /* Tapping a link inside the panel (that navigates away) should close it
       so when the new page paints, the panel isn't still showing. We only
       close on real <a> elements with an href — ignore <summary> taps and
       the view-all parent link for which the browser will navigate anyway. */
    panel.addEventListener('click', function (e) {
      var a = e.target.closest('a[href]');
      if (!a) return;
      /* allow modifier + middle-click pass-through */
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
      /* Hash-only links don't navigate; still close for UX */
      closePanel();
    });

    /* Close if viewport grows past the mobile breakpoint (user rotated /
       resized into tablet range) */
    var mql = window.matchMedia('(min-width: 750px)');
    if (mql && mql.addEventListener) {
      mql.addEventListener('change', function (e) {
        if (e.matches && panel.classList.contains('is-open')) closePanel();
      });
    }

    /* ── Touch drag-to-dismiss on the grab handle ────────────────── */
    if (handle && sheet) {
      var startY = 0;
      var currentY = 0;
      var dragging = false;
      var sheetHeight = 0;

      function onTouchStart(e) {
        if (!panel.classList.contains('is-open')) return;
        var t = e.touches ? e.touches[0] : e;
        startY = t.clientY;
        currentY = startY;
        sheetHeight = sheet.offsetHeight;
        dragging = true;
        sheet.classList.add('is-dragging');
      }

      function onTouchMove(e) {
        if (!dragging) return;
        var t = e.touches ? e.touches[0] : e;
        currentY = t.clientY;
        var delta = Math.max(0, currentY - startY);
        sheet.style.transform = 'translateY(' + delta + 'px)';
        /* Fade backdrop proportionally */
        var backdrop = panel.querySelector('.tyk-mobnav-panel__backdrop');
        if (backdrop) {
          var pct = Math.max(0, 1 - (delta / sheetHeight));
          backdrop.style.opacity = String(pct);
        }
        if (e.cancelable) e.preventDefault();
      }

      function onTouchEnd() {
        if (!dragging) return;
        dragging = false;
        sheet.classList.remove('is-dragging');
        var delta = currentY - startY;
        sheet.style.transform = '';
        var backdrop = panel.querySelector('.tyk-mobnav-panel__backdrop');
        if (backdrop) backdrop.style.opacity = '';
        /* If pulled down more than 25% of sheet height, dismiss */
        if (delta > sheetHeight * 0.25) {
          closePanel();
        }
      }

      handle.addEventListener('touchstart', onTouchStart, { passive: true });
      handle.addEventListener('touchmove', onTouchMove, { passive: false });
      handle.addEventListener('touchend', onTouchEnd);
      handle.addEventListener('touchcancel', onTouchEnd);
    }
  }
})();
